import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

// UM socket so para a aplicacao inteira, que nunca e trocado por outro.
//
// Antes, quando o token mudava (o /auth/refresh_token gera um token novo a
// cada carregamento da pagina), era criado um socket NOVO e o antigo era
// desligado. Quem ja tinha registrado ouvintes no antigo -- por exemplo a
// lista de conexoes (useWhatsApps), que alimenta o aviso "numero
// desconectado" do atendimento -- ficava surdo ate o proximo F5. Por isso o
// aviso nao sumia quando a conexao voltava.
//
// Agora, se o token mudar, so atualizamos o token e reconectamos ESTE mesmo
// socket: todos os ouvintes continuam pendurados nele.
let socket;
let currentToken = null;

function lerToken() {
  try {
    return JSON.parse(localStorage.getItem("token"));
  } catch (e) {
    return null;
  }
}

function connectToSocket() {
  const token = lerToken();

  if (!socket) {
    currentToken = token;
    socket = openSocket(getBackendUrl(), {
      transports: ["websocket", "polling", "flashsocket"],
      query: { token },
    });
    return socket;
  }

  if (currentToken !== token) {
    currentToken = token;
    // O token vai no handshake; reconectar faz o servidor receber o novo.
    socket.io.opts.query = { ...(socket.io.opts.query || {}), token };
    socket.disconnect();
    socket.connect();
    return socket;
  }

  if (socket.disconnected) {
    socket.connect();
  }
  return socket;
}

export default connectToSocket;
